export enum PromiseStatus {
  Pending,
  Fulfilled,
  Rejected,
  Settled,
}
